export default (srv, window) => {
	const siteId = srv('Analytics.matomoSiteId')
	if (!siteId) return

	window._paq = window._paq || []
	const u =
		process.env.NODE_ENV == 'development' ? 'http://localhost:8080/' : 'https://analytics.drubbitapps.com/'
	window._paq.push(['enableLinkTracking'])
	window._paq.push(['setTrackerUrl', u + 'matomo.php'])
	window._paq.push(['setSiteId', siteId])

	const dimensionsMap = srv('Analytics.matomoDimensionsMap')
	if (dimensionsMap?.device_type) {
		let deviceType
		switch (srv('deviceType')) {
			case 'phone':
				deviceType = 'mobile'
				break
			case 'tablet':
				deviceType = 'tablet'
				break
			default:
				deviceType = 'desktop'
				break
		}
		window._paq.push(['setCustomDimension', dimensionsMap.device_type, deviceType])
	}

	if (dimensionsMap?.site_context) {
		let contextName = srv('contextName')
		if (contextName) {
			window._paq.push(['setCustomDimension', dimensionsMap.site_context, contextName])
		}
	}

	const g = document.createElement('script')
	const s = document.getElementsByTagName('script')[0]
	g.type = 'text/javascript'
	g.async = true
	g.src = u + 'matomo.js'
	s.parentNode.insertBefore(g, s)

	return (...commands) => {
		for (let command of commands) {
			window._paq.push(command)
		}
	}
}

